<template>
<div class="master_wrapp">
    <div class="demo-content">
      <section class="container_wrap">
        <article>
            <h1 class="card-title logo_text text-center" uk-scrollspy="cls: uk-animation-slide-top;delay:100"  >
             <img :src="get_setting_app.logo" alt="logo">
               <!-- <img
                    src="@/assets/logo_s.png"
                    alt="elgeseter"
                > -->
              
              </h1>
            <template>
              <div v-for="omoss  in get_setting_app.menu_top" :key="omoss.id">
               <div uk-scrollspy="cls: uk-animation-slide-top-medium;delay:550" v-if="omoss.link=='/om-oss'" v-html="omoss.text"></div>
                <div v-if="omoss.link=='/om-oss'" class="gif_img" uk-scrollspy="cls: uk-animation-slide-top-medium;delay:1000">
             <img class="omoss_img_down" :src="omoss.image" alt="">
             </div>
              </div>
              
            </template>
        </article>
    
      </section>
    </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
    export default {
        name:'about-us',
        computed:{
            ...mapGetters({
                 get_setting_app:'get_setting_app',
            })
        }
    }
</script>
<style lang="scss">
.master_wrapp{
  h1{
     font-size: 25px;
    font-weight: 700;
    color: #3d745c !important;
    margin-bottom: 20px;
  }
  h2{
    color: #6b1813 !important;
  }
 html, body, p, ol, ul, li, dl, dt, dd, blockquote, figure, fieldset, legend, textarea, pre, iframe, hr, h3, h4, h5, h6{
    color: #231f20 !important;
  }
  .omoss_img_down{
    margin-top: 50px;
  }
}

</style>
<style lang="scss" scoped>
body p {
    margin-bottom: 1.5rem;
  }

  
  .title_1{
font-size: 25px;
    font-weight: 700;
    color: var(--active_color);
    margin-bottom: 20px;
  }
  .hello{
     color: var(--active_color2);
  }
  .gif_img{
      text-align: center;
       border-radius: 20px;
      img{
          width: 300px;
          height: 280px;
          object-fit: contain;
          border-radius: 20px;
      }
  }
  .logo_text{
      img{
          width: 240px;
          object-fit: contain;
      }
      margin-bottom: 30px;
  }
  .demo-content .container_wrap {
    max-width: 600px;
    margin: 4rem auto;
    color: black;
    font-size: 17px;
  }
  .master_wrapp{
    padding-top: 0px;
  }
  .demo-content .container_wrap article {
    padding: 2rem;
    background: #f5f5f5;
    position: relative;
    margin: 0 0 4rem 0;
    box-shadow: 2px -1px 6px 6px #3030306b;
    color: #282325;
  }
  .demo-content .container_wrap article:hover:after {
    transform: rotate(0);
    box-shadow: none;
    background: transparent;
  }
  .demo-content .container_wrap article:after {
    width: 100%;
    top: 0.2rem;
    z-index: -1;
    left: 0.2rem;
    height: 100%;
    content: " ";
    position: absolute;
    transition: all 1.5s;
    transform: rotate(3deg);
    -webkit-transition: all 1.5s;
    background: white;
    box-shadow: 3px 4px 0 0 white, 5px 7px 0 0 #e5e5e5;
  }
  .demo-content .container_wrap .author {
    color: rgba(0, 0, 0, 0.4);
    text-align: center;
  }
  .demo-content .container_wrap .author a {
    color: inherit;
    font-size: 0.8rem;
  }

  .flex_clients{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    margin-top: 40px;
  }
  .clients_img{
      flex:  0 0 40%;
  }
  .flex_clients img{
      width: 100%;
      height: 110px;
      object-fit: contain;
      object-position: center;
  }
  @media(max-width:767px)
  {
    .demo-content .container_wrap article:after {
    display: none !important;
    }
    .demo-content .container_wrap {
        margin: 4rem auto;
      }
  }
</style>